import { USER_FAILURE, USER_REQUEST, USER_SUCCESS } from "../action/UserSession";


const initialState = {
  sessionData: null,
  loading: false,
  error: null,
  userData: ''
};

const userReducer = (state = initialState, action) => {
  switch (action.type) {
    case USER_REQUEST:
      return {
        ...state,
        loading: true,
        error: null,
      };
    case USER_SUCCESS:
      return {
        ...state,
        loading: false,
        sessionData: action.payload,
      };
    case USER_FAILURE:
      return {
        ...state,
        loading: false,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
